/* Love N Care — launch offer (Oct 2026) countdowns + switch-off at the end date, and the newsletter pop-up
   ($20 off a first order, WELCOME20 — the only pop-up version since the launch ended on 18 Oct).
   Config comes from window.LNC_LAUNCH (snippets/lnc-launch.liquid via layout/theme.liquid). */
(function () {
  var L = window.LNC_LAUNCH;
  if (!L) return;
  var root = document.documentElement;
  var start = Date.parse(L.start), end = Date.parse(L.end);

  /* A tab left open across the end time drops the offer without a reload. */
  var left = end - Date.now();
  if (left > 0 && left < 864e5) setTimeout(function () { root.classList.remove('lnc-launch-on'); root.classList.add('lnc-launch-post'); }, left + 1000);

  /* Countdowns: <span data-lnc-countdown></span> → "10 days 4 hrs left" (minutes on the last day). */
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
  function tick() {
    var ms = end - Date.now();
    // only the launch's own countdowns (the sale hero's carries data-deadline and runs its own timer)
    document.querySelectorAll('[data-lnc-countdown]:not([data-deadline])').forEach(function (el) {
      if (ms <= 0) { el.textContent = 'The draw has closed'; return; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
      el.textContent = (d ? plural(d, 'day') + ' ' + plural(h, 'hr') : h ? plural(h, 'hr') + ' ' + plural(m, 'min') : plural(Math.max(m, 1), 'min')) + ' left';
    });
  }
  tick();
  setInterval(tick, 60000);

  /* Any newsletter sign-up that just succeeded (pop-up, footer, homepage band, draw page) — remember it so the
     bag can say "you're subscribed" instead of asking again (lnc-ship-offer.js). */
  if (/[?&]customer_posted=true/.test(location.search)) { try { localStorage.setItem('lnc-lpop', 'subscribed'); } catch (e) {} }

  /* ---- Sign-up pop-up: $20 off a first order of $149+ (WELCOME20) ----
     From 19 Oct 2026 the only version (the launch A/B/C test ended with the launch on 18 Oct; this was 'c').
     Opens by itself once per visitor (12 s, 45% scroll, or exit intent on desktop). Visitors who already saw a
     launch version get this one once too: it uses its own key (lnc-wpop). Anyone who has subscribed on this
     browser (lnc-lpop = 'subscribed') is never asked. Views, submits and sign-ups go to the lnc-alerts worker
     (/pop, version 'c', counts only — no personal data).
     ?lnc_pop=c opens it straight away for testing and marks the browser session as QA, so test visits stay out
     of the counts. On an unpublished theme, ?lnc_pop_thanks=c previews the thank-you message (a real sign-up
     needs Shopify's captcha, which automated tests can't pass). */
  var pop = document.querySelector('[data-lnc-lpop]');
  if (!pop) return;
  var SUB = 'lnc-lpop', SEEN = 'lnc-wpop', FLAG = 'lnc-lpop-sent', QAKEY = 'lnc-lpop-qa';
  var TRACK = 'https://lnc-alerts.square-voice-ee10.workers.dev/pop';
  var V = 'c', CODE = 'WELCOME20';
  function get(k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } }
  function set(k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }
  function param(name) { return (location.search.match(new RegExp('[?&]' + name + '=([abc])(?:&|$)')) || [])[1]; }

  var forced = param('lnc_pop');
  if (forced) set(QAKEY, '1', true);
  var qa = !!get(QAKEY, true);
  var panel = pop.querySelector('.lnc-lpop__panel');

  function track(e) {
    try {
      fetch(TRACK, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'content-type': 'text/plain' },
        body: JSON.stringify(qa ? { v: V, e: e, qa: true } : { v: V, e: e }) });
    } catch (err) {}
  }
  function applyCode() {
    // put the code on the bag so it comes off at checkout without typing it (Ajax cart API `discount`)
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: CODE }) })
      .then(function (r) { if (r.ok) { var n = pop.querySelector('[data-lpop-applied]'); if (n) n.hidden = false; } })
      .catch(function () {});
  }
  function showThanks() {
    pop.querySelectorAll('[data-lpop-form], [data-lpop-form-only]').forEach(function (el) { el.hidden = true; });
    var done = pop.querySelector('[data-lpop-success]');
    if (done) done.hidden = false;
    var later = pop.querySelector('.lnc-lpop__later');
    if (later) later.textContent = 'Close';
    applyCode();
  }

  var lastFocus = null;
  function open() {
    if (!pop.hidden) return;
    lastFocus = document.activeElement;
    pop.hidden = false;
    requestAnimationFrame(function () { pop.classList.add('is-open'); });
    root.classList.add('lnc-lpop-lock');
    var input = pop.querySelector('.lnc-lpop__input');
    var typing = input && !input.closest('[hidden]') && window.matchMedia('(min-width: 750px)').matches;
    setTimeout(function () { (typing ? input : panel).focus({ preventScroll: true }); }, 60);
    set(SEEN, '1');
  }
  function close() {
    pop.classList.remove('is-open');
    root.classList.remove('lnc-lpop-lock');
    setTimeout(function () { pop.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  pop.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-lpop-copy]');
    if (copy) {
      var copied = function () { copy.textContent = 'Copied ✓'; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(copy.getAttribute('data-lpop-copy')).then(copied, function () {});
      return;
    }
    if (e.target.closest('[data-lpop-close]')) close();
  });
  /* Any [data-lnc-lpop-open] link or button opens the pop-up */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-lnc-lpop-open]');
    if (!t) return;
    e.preventDefault();
    if (!pop.hidden) return;
    open();
    track('shown');
  });
  // keyup, not keydown: closing on keydown moved focus back into the bag drawer, whose own Escape (keyup)
  // handler then closed the bag as well
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
  var form = pop.querySelector('form');
  if (form) form.addEventListener('submit', function () { set(FLAG, V, true); track('submit'); });

  /* Back from a submit (Shopify reloads the page with ?customer_posted=true, sometimes via its captcha page):
     show the thank-you and code once, and never ask again. */
  var sent = get(FLAG, true);
  if (sent && /[?&]customer_posted=true/.test(location.search)) {
    try { sessionStorage.removeItem(FLAG); } catch (e) {}
    showThanks();
    open();
    track('signup');
    return;
  }
  // Shopify sent the form back with an error (e.g. a mistyped email): reopen it to show the message
  if (sent && pop.querySelector('[data-lpop-error]')) {
    try { sessionStorage.removeItem(FLAG); } catch (e) {}
    open();
    return;
  }
  if (param('lnc_pop_thanks') && window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') { showThanks(); open(); return; }
  if (forced) { open(); track('shown'); return; }
  if (get(SUB) === 'subscribed' || get(SEEN)) return;
  if (/^\/(cart|checkout|checkouts|account|challenge|password|policies)(\/|$)/.test(location.pathname)) return;

  var armed = true;
  function maybeOpen() {
    if (!armed || get(SEEN)) return;
    // never on top of the bag drawer or another dialog
    if (document.querySelector('cart-drawer.active, cart-drawer[open], .drawer.active, details[open] > .menu-drawer, .lnc-so.is-open')) return;
    armed = false;
    open();
    track('shown');
  }
  setTimeout(maybeOpen, 12000);
  window.addEventListener('scroll', function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h > 0.45) { window.removeEventListener('scroll', onScroll); maybeOpen(); }
  }, { passive: true });
  if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) maybeOpen(); });
  }
})();
